<template>
  <el-col v-if="canAction('shipping_bids_edit')" id="day-prices" :span="4">
    <template v-if="day.type_code !== 'harvest'">
      <p v-if="!isDispatcherRole" class="blue">
        <b>
          {{ day.price_from_storage_bidder | getPrice }}
          <span v-if="day.type_code === 'harvest_or_delivery'">(П)</span>
        </b>
      </p>
      <p
        v-if="isAdminOrCeoRole || isDispatcherRole"
        :class="day.price_from_storage_driver ? 'green' : 'red'"
      >
        <b>
          {{ day.price_from_storage_driver | getPrice }}
          <span v-if="day.type_code === 'harvest_or_delivery'">(П)</span>
        </b>
      </p>
    </template>
    <template v-if="day.type_code !== 'delivery'">
      <p v-if="!isDispatcherRole" class="blue">
        <b>
          {{ day.price_from_field_bidder | getPrice }}
          <span v-if="day.type_code === 'harvest_or_delivery'">(У)</span>
        </b>
      </p>
      <p
        v-if="isAdminOrCeoRole || isDispatcherRole"
        :class="day.price_from_storage_driver ? 'green' : 'red'"
      >
        <b>
          {{ day.price_from_field_driver | getPrice }}
          <span v-if="day.type_code === 'harvest_or_delivery'">(У)</span>
        </b>
      </p>
    </template>
  </el-col>
</template>

<script>
export default {
  name: 'DayPrices',
  props: {
    day: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="sass">
#day-prices
  p
    text-align: center
    margin: 0
    line-height: 20px
    font-size: 14px
    color: #3D3D3D
    &.green
      color: #589839
    &.blue
      color: #3498DB
    &.red
      color: #ff0000
</style>
